// Shared data for Atlas Forge
// FIXED per M-017 (2026-08-13, storefront-seo dept, web-theme-developer draft).
// Baseline was fetched verbatim from the live MAIN theme
// (gid://shopify/OnlineStoreTheme/143353479266) on 2026-08-13 — see
// "2026-08-13 M-017 live-baseline data.js" in this outbox for the untouched original.
// orders[] and suppliers[] were already emptied 2026-08-12 (prior approval) — left empty, untouched.
// products[] STRIPPED 2026-08-13 per approved decision (_Approvals\2026-08-12
// data-js-fake-catalogue-wipe.md, approved 2026-08-13 19:38): removed the fabricated
// cost/supplier/aliId fields (fake COGS, invented supplier names, fake AliExpress IDs) that
// were publicly readable by anyone viewing this file on the live store. id/name/price/cat/
// status/stock/sku/eta/tag are unchanged. Array is still 12 items, same shape minus those
// three fields — kept as a valid fallback since window.ATLAS_PRODUCTS_LIVE /
// atlas-shopify-bridge.js overwrites it at runtime with real Shopify product data.

window.ATLAS_DATA = {
  categories: [
    { slug: 'rings', name: 'Rings', count: 14, rune: 'ᚱ' },
    { slug: 'necklaces', name: 'Necklaces', count: 22, rune: 'ᚾ' },
    { slug: 'earrings', name: 'Earrings', count: 18, rune: 'ᛖ' },
    { slug: 'bracelets', name: 'Bracelets', count: 9, rune: 'ᛒ' },
  ],

  products: [
    { id:'p01', name:'Viking Vegvisir Compass Ring', price:60.00, cat:'rings',      status:'in_stock',  stock: 47, sku:'ATL-R-001', eta:'11-18d', tag:'bestseller' },
    { id:'p02', name:'Gold Huggie Hoop Earrings',     price:19.99, cat:'earrings',  status:'sold_out',  stock: 0,  sku:'ATL-E-012', eta:'10-16d' },
    { id:'p03', name:'Minimalist Stainless Chain Necklace', price:19.99, cat:'necklaces', status:'sold_out', stock:0, sku:'ATL-N-004', eta:'12-20d' },
    { id:'p04', name:'Minimalist Stackable Ring',     price:14.99, cat:'rings',     status:'low',       stock: 4,  sku:'ATL-R-007', eta:'11-18d' },
    { id:'p05', name:'Minimalist Stainless Stud Earrings', price:15.99, cat:'earrings', status:'in_stock', stock: 31, sku:'ATL-E-021', eta:'10-16d' },
    { id:'p06', name:'Norse Rune Open Cuff Bangle',   price:29.99, cat:'bracelets', status:'in_stock',  stock: 19, sku:'ATL-B-003', eta:'13-19d', tag:'new' },
    { id:'p07', name:'Stainless Steel Disc Pendant',  price:22.99, cat:'necklaces', status:'in_stock',  stock: 12, sku:'ATL-N-009', eta:'12-20d' },
    { id:'p08', name:'Mjölnir Hammer Pendant',        price:34.99, cat:'necklaces', status:'in_stock',  stock: 26, sku:'ATL-N-011', eta:'13-19d', tag:'new' },
    { id:'p09', name:'Jörmungandr Serpent Ring',      price:42.99, cat:'rings',     status:'in_stock',  stock: 8,  sku:'ATL-R-014', eta:'11-18d' },
    { id:'p10', name:'Raven Silhouette Earrings',     price:18.99, cat:'earrings',  status:'in_stock',  stock: 44, sku:'ATL-E-028', eta:'10-16d' },
    { id:'p11', name:'Black Obsidian Rune Bead Bracelet', price:26.99, cat:'bracelets', status:'in_stock', stock: 16, sku:'ATL-B-007', eta:'13-19d' },
    { id:'p12', name:'Valknut Signet Ring',           price:38.99, cat:'rings',     status:'in_stock',  stock: 22, sku:'ATL-R-019', eta:'11-18d' },
  ],

  // REMOVED 2026-08-12 — fabricated order records must not be served by a public store.
  orders: [],

  // REMOVED 2026-08-12 — fabricated supplier records.
  suppliers: [],

  stateLabels: {
    paid:         { label:'Paid · Awaiting auto-order', color:'blue',  icon:'•' },
    ali_ordered:  { label:'Ordered on AliExpress',       color:'gold',  icon:'◈' },
    shipped:      { label:'Shipped',                     color:'gold',  icon:'→' },
    delivered:    { label:'Delivered',                   color:'green', icon:'✓' },
    dispute:      { label:'Dispute open',                color:'red',   icon:'!' },
  },

  // Simple route table for the nav
  routes: {
    home:     { title:'Home',       file:'index.html' },
    jewelry:  { title:'Jewelry',    file:'jewelry.html' },
    cart:     { title:'Cart',       file:'cart.html' },
    checkout: { title:'Checkout',   file:'checkout.html' },
  },
};

window.formatNIS = (n) => '₪' + n.toFixed(2);
window.formatUSD = (n) => '$' + n.toFixed(2);
